import { ComponentType } from 'react';
import { ComponentBuilderEquipped } from './equipped';
import { ComponentBuilderBlank } from './blank';

type ComponentBuilderFn = {
  <P extends object>(Component: ComponentType<P>): ComponentBuilderEquipped<P>;
  <P extends object = object>(): ComponentBuilderBlank<P>;
};

const _componentBuilder = <P extends object = object>(Component?: ComponentType<P>) => {
  if (Component) {
    return new ComponentBuilderEquipped<P>(Component);
  }
  return new ComponentBuilderBlank<P>();
};

/**
 * Creates a builder instance for composing React components with HOCs.
 * - If a component is provided, returns a builder pre-equipped with that component.
 * - If no component is provided, returns a blank builder for later composition.
 *
 * @param Component - Optional React component to enhance.
 * @returns A builder instance for chaining HOCs and building enhanced components.
 */
export const _experimentalComponentBuilder = _componentBuilder as ComponentBuilderFn;
